import { Separator } from '@/components/ui/Separator';
import { getKeycloakSubject } from '@/features/Keycloak/keycloakService';
import { AuditLog, AuditLogInsertInput } from '@/generated/graphql';
import {
  AuditLogAction,
  AuditLogActionMap,
  AuditLogActorMap,
  AuditLogActorType,
  AuditLogEntry,
} from '@/models/audit-log.models';
import { UTC_ZONE } from '@/models/time.models';
import { DateTime } from 'luxon';
import { v4 as uuid } from 'uuid';

export const createAuditLogInput = (
  logEntry: AuditLogEntry,
): AuditLogInsertInput => {
  return {
    id: uuid(),
    entities: logEntry.entities,
    action: logEntry.action,
    actorId: getKeycloakSubject(),
    actorType: AuditLogActorType.USER,
    createdAt: new Date().toISOString(),
    data: {},
  };
};

export function createAuditLogTitle(log: AuditLog): React.ReactNode {
  return (
    <div className="mb-1 flex flex-wrap gap-x-2">
      <div className="text-muted-foreground flex w-[180px]">
        {DateTime.fromISO(log.createdAt, {
          zone: UTC_ZONE,
        })
          .toLocal()
          .toLocaleString(DateTime.DATETIME_MED_WITH_SECONDS)}
      </div>
      <div className="flex">
        {AuditLogActorMap[log.actorType as AuditLogActorType]}{' '}
        <span className="mx-1 font-semibold">{log.aspNetUser?.userName}</span>
        {AuditLogActionMap[log.action as AuditLogAction] ?? log.action}
      </div>
      <Separator />
    </div>
  );
}
